import { dangerousHtmlStringWrapper, getLinkMarkerUrl, isInternalLink } from './utils';

export const utils = {
  dangerousHtmlStringWrapper,
  getLinkMarkerUrl,
  isInternalLink,
};
